import { Box, Container, Typography } from "@material-ui/core";
import React, { Fragment, useContext, useEffect, useState } from "react";
import BuyTicketWrapper from "../components/BuyTicketWrapper";
import PayJp from "../components/PayJp";
import BreadCrumbs from "../components/BreadCrumbs";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { AuthContext } from "../auth/AuthContext";
import { httpGet } from "../lib/apiClients";
import CouponWrapper from "../components/CouponWrapper";
import LoaderComponent from "../components/LoaderComponent";
import BuyType from "../components/BuyType";
import SectionHeader from "../components/SectionHeader";
import { UserDataContext } from "../context/UserDataContext";
import BreadCrumbLinks from "../components/BreadCrumbLinks";
import ConcernTextArea from "../components/ConcernTextArea";
import DeviceSelect from "../components/DeviceSelect";
import RemoteSupportSelect from "../components/RemoteSupportSelect";
interface ChargeData {
  couponList: [];
  product: any | null | undefined;
  creditcard: object | null | undefined;
  staff: any;
}

export default function BuyPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const { currentUser } = useContext(AuthContext);
  const { state } = useLocation();
  const [chargeData, setChargeData] = useState<ChargeData | undefined>(
    undefined
  );
  const [couponData, setCouponData] = useState<object | undefined>(undefined);
  const [concernText, setConcernText] = useState(
    sessionStorage.getItem("concernText") || ""
  );
  const [concernTextError, setConcernTextError] = useState(false);
  const [productInfo, setProductInfo] = useState<any | null>(null);
  const { getCouponData, fetchCoupon } = useContext(UserDataContext);
  const [deviceSelect, setDeviceSelect] = useState({
    device: "",
    os: "",
  });
  const [remoteSupport, setRemoteSupport] = useState("");
  const [buyType, setBuyType] = useState<string>(
    sessionStorage.getItem("buyType") || "TEL"
  );

  const productId =
    searchParams.get("productId") ||
    sessionStorage.getItem("productId") ||
    undefined;
  const reserveNowParam =
    searchParams.get("reserveNow") ||
    sessionStorage.getItem("reserveNow") ||
    false;
  const staffIdParam =
    searchParams.get("staffId") || sessionStorage.getItem("staffId") || false;

  useEffect(() => {
    document.title = "支払い画面 | じぶん専用IT相談室";
    if (currentUser === undefined) return;

    if (!currentUser) {
      navigate("/login", {
        state: {
          from: window.location.pathname,
          search: window.location.search,
        },
      });
    } else {
      if (sessionStorage.getItem("params")) {
        setSearchParams(JSON.parse(sessionStorage.getItem("params") || "{}"));
      }
      if (state) {
        sessionStorage.setItem("state", JSON.stringify(state));
        sessionStorage.setItem("productId", state.productId);
      }
      if (sessionStorage.getItem("state")) {
        setProductInfo(JSON.parse(sessionStorage.getItem("state") || "{}"));
      }
      fetchCoupon();
      getChargeData();
    }
  }, [currentUser]);

  /**
   * Get Charge Data
   */
  const getChargeData = async () => {
    if (!productId) {
      navigate("/support/menu");
    }

    const params = {
      productId,
      ...(staffIdParam && { staffId: staffIdParam }),
    };

    try {
      await httpGet({
        pathName: "charge-data",
        queryParams: params,
      }).then((response) => {
        var data = response.data;
        setChargeData(data);
        console.log(data);
        if (
          !reserveNowParam &&
          data.product.productType === "SUPPORT" &&
          !sessionStorage.getItem("state")
        ) {
          navigate("/support/menu", { state: { displayToast: true } });
        }
      });
    } catch (error) {
      console.log(error.response.data.message);
      if (
        error?.response?.status == 400 &&
        error.response.data.message == "Staff Not Found."
      ) {
        navigate("/error?code=404");
      } else if (error.response.status >= 400 && error.response.status <= 499) {
        navigate("/support/menu", { state: { displayToast: true } });
      } else {
        navigate(`/error?code=${error.response.status || "400"}`);
      }
    }
  };
  function handleBackToStaffPage() {
    navigate(`/support/staff?productId=${productInfo.ticket.productId}`, {
      state: { ticket: productInfo.ticket },
    });
  }
  console.log(getCouponData);
  return (
    <Box className="buy-page">
      {chargeData ? (
        <Fragment>
          {chargeData?.product?.productType == "SUPPORT" &&
            reserveNowParam == false && (
              <BreadCrumbLinks
                currentPage={"お支払い"}
                cf={handleBackToStaffPage}
              />
            )}

          <Box className="section-50 bg-dots " component={"section"}>
            {!["INTERVIEW", "TIP", "ADD"].includes(
              chargeData.product.productType
            ) && reserveNowParam == false ? (
              <BreadCrumbs currentPage={"お支払い"} preHeading="Payment" />
            ) : (
              <SectionHeader currentPage={"お支払い"} preHeading="Payment" />
            )}

            <Container className="container">
              <Typography className="page-description">
                お申し込み内容で注文を確定します
                <br />
                チケット購入手続きをお願いいたします。
              </Typography>
              <Typography className="section-heading">
                お申し込み内容
              </Typography>
              {chargeData && (
                <BuyTicketWrapper
                  product={chargeData.product}
                  state={productInfo}
                  couponData={couponData}
                  staffData={chargeData.staff}
                />
              )}
            </Container>
          </Box>
          {chargeData && getCouponData && getCouponData.couponList?.length ? (
            <CouponWrapper
              coupon={getCouponData.couponList}
              chargeData={chargeData}
              setCouponData={setCouponData}
            />
          ) : (
            ""
          )}
          {chargeData &&
            ["SUPPORT"].includes(chargeData.product.productType) && (
              <Fragment>
                <ConcernTextArea
                  heading={"【任意】具体的なお悩みや現状を記入する"}
                  subHeading={
                    "こちらに具体的なお悩みや現状をご記入ください。事前に記入いただくとスムーズにご案内できます。"
                  }
                  placeholder={
                    "例：パソコン画面が真っ暗になった、インターネットが接続できない、クレジット会社から不正利用されているとメールが届いた等"
                  }
                  concernText={concernText}
                  setConcernText={setConcernText}
                  concernTextError={concernTextError}
                  setConcernTextError={setConcernTextError}
                />
                <DeviceSelect
                  deviceSelect={deviceSelect}
                  setDeviceSelect={setDeviceSelect}
                />
                <RemoteSupportSelect
                  remoteSupport={remoteSupport}
                  setRemoteSupport={setRemoteSupport}
                />
              </Fragment>
            )}
          {chargeData &&
            !["INTERVIEW", "TIP", "ADD"].includes(
              chargeData.product.productType
            ) &&
            reserveNowParam == false && (
              <BuyType setBuyType={setBuyType} buyType={buyType} />
            )}

          <Box className="section-50 bg-dots" component={"section"}>
            <Container className="container">
              <Typography className="section-heading">
                お支払い情報入力
              </Typography>
              <PayJp
                chargeData={chargeData}
                state={productInfo}
                productId={productId}
                couponData={couponData}
                buyType={buyType}
                setCoupon={setCouponData}
                concernText={concernText}
                concernTextError={concernTextError}
                setConcernTextError={setConcernTextError}
                productInfo={productInfo}
                deviceSelect={deviceSelect}
                remoteSupport={remoteSupport}
              />
            </Container>
          </Box>
        </Fragment>
      ) : (
        <LoaderComponent />
      )}
    </Box>
  );
}
